// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VjnS","newExpiryDate":"styles_newExpiryDate__3TbMd","footer":"styles_footer__3Oflc"};